<div class="w-full border-b border-border-secondary">
  <!-- Accordion Trigger -->
  <h3 class="w-full p-5" (click)="toggleIsActive()">
    <button type="button" class="h-[36px] w-full flex justify-between items-center focus-outline">
      <div class="flex flex-row gap-2">
        <lds-icon [name]="panelIcon()"> </lds-icon> <span class="text-body-1-desktop font-medium">{{ title() }} </span>
      </div>
      @if (isActive()) {
        <lds-icon [name]="Icon.CHEVRON_UP"> </lds-icon>
      } @else {
        <lds-icon [name]="Icon.CHEVRON_DOWN"> </lds-icon>
      }
    </button>
  </h3>
  <!-- Accordion Panel -->
  @if (isActive()) {
    <div class="px-5 pb-5">
      <ng-content />
    </div>
  }
</div>
